import { createStyles } from '@mantine/core'

export const useStyles = createStyles((theme) => ({
    navigationButtons: {
        '& button': {
            maxWidth: 200,
            [theme.fn.smallerThan('sm')]: {
                maxWidth: 'none',
            },
        },
    },
    nextBtn: {
        [theme.fn.smallerThan('sm')]: {
            order: 1,
        },
    },
    prevBtn: {
        [theme.fn.smallerThan('sm')]: {
            order: 2,
        },
    },
}))
